import { Component, OnInit, OnDestroy } from '@angular/core';
import { UsuarioBeanResponse } from 'src/app/modal/usuario/usuario-bean-response';
import { UsuarioResponse } from 'src/app/modal/usuario/usuario-response';
import { UsuarioService } from 'src/app/service/usuario/usuario.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-mi-cuenta',
  templateUrl: './mi-cuenta.component.html',
  styleUrls: ['./mi-cuenta.component.scss']
})
export class MiCuentaComponent implements OnInit, OnDestroy {
  usuarioSesion: UsuarioResponse;
  datosUsuario:UsuarioBeanResponse;
  private subscripcionActualizacion: Subscription;

  constructor(private usuarioService:UsuarioService) { }

  obtenerDatosUsuario(){
   this.usuarioSesion = this.usuarioService.obtenerSesionUsuario();
  }


  obtenerInformacion(){
    this.datosUsuario = new UsuarioBeanResponse();
    this.usuarioService.obtenerUser(this.usuarioService.obtenerIDSessionUsuario()).subscribe(data=>{
      this.datosUsuario = data;
     
    })
  }

  nombreUsuario(){
    return this.usuarioSesion.response.list[0].name + " " + this.usuarioSesion.response.list[0].surname
  }
  ngOnInit(): void {
    this.obtenerDatosUsuario();
    this.obtenerInformacion();

    // Suscribirse a cambios en los datos del usuario
    this.subscripcionActualizacion = this.usuarioService.onDatosUsuarioActualizados.subscribe(() => {
      // Actualizar los datos cuando se notifique un cambio
      this.obtenerDatosUsuario();
      this.obtenerInformacion();
    });
  }

  ngOnDestroy(): void {
    // Limpiar la suscripción al destruir el componente
    if (this.subscripcionActualizacion) {
      this.subscripcionActualizacion.unsubscribe();
    }
  }

}
